import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_AIR_HANDLING_UNIT',
  GET: 'GET_AIR_HANDLING_UNIT',
  CREATE: 'CREATE_AIR_HANDLING_UNIT',
  EDIT: 'EDIT_AIR_HANDLING_UNIT',
  DELETE: 'DELETE_AIR_HANDLING_UNIT',
  DUPLICATE: 'DUPLICATE_AIR_HANDLING_UNIT',
  CLEAR_ERROR: 'CLEAR_ERROR_AIR_HANDLING_UNIT',
};

export const clearErrorAirHandlingUnit = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchAirHandlingUnitByText = (text, page = 0) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchAirHandlingUnit(pageSize, page, sorted, filtered, isPublic);
};

export const searchAirHandlingUnit = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_AIR_HANDLING_UNIT,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const listAirHandlingUnit = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchAirHandlingUnit(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const getAirHandlingUnit = id => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_AIR_HANDLING_UNIT}${id}/`,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createAirHandlingUnit = (name, type, coolingCap, unitId, powerRequired, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('type', type);
  formData.set('cooling_capacity', coolingCap);
  formData.set('unit', unitId);
  formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `acct_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_AIR_HANDLING_UNIT,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editAirHandlingUnit = (id, name, type, coolingCap, unitId, powerRequired, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (type) formData.set('type', type);
  if (coolingCap) formData.set('cooling_capacity', coolingCap);
  if (unitId) formData.set('unit', unitId);
  if (powerRequired) formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `acct_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_AIR_HANDLING_UNIT}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteAirHandlingUnit = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_AIR_HANDLING_UNIT}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateAirHandlingUnit = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_AIR_HANDLING_UNIT}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/ac_central/air_handling_unit_actions.js